import ResultsFormatterBase from "../../formatters/ResultsFormatterBase.js";
import { 
    ResultData, ResultType,
} from "../../enums/index.js";

/**
 * this formatter allows to change results structure v2 into old structure used in entire library
 */
class SessionResultsStructureFormatter extends ResultsFormatterBase{
    constructor(skipAwaiting) {
        super();
        this.resultStructure = {};

        if (typeof(skipAwaiting) === 'undefined') {
            skipAwaiting = true;
        }

        this.skipAwaiting = !!skipAwaiting;

        for (const key in ResultData) {
            if (Object.hasOwnProperty.call(ResultData, key)) {
                const property = ResultData[key].key;
                if (!property) {
                    continue;
                }
                this.resultStructure[property] = null;
            }
        }
    }

    /**
     * Provides v2 to v1 result structure formatting
     * todo - generator ?
     * @param {Array} results  compatible with v2 structure, see https://bitbucket.org/flightscope/dto-schema/src/1.0.1/baseball/entity/result-v2.json
     * @returns {Array} of results compatible with v1 structure, see https://bitbucket.org/flightscope/dto-schema/src/1.0.1/baseball/entity/result-v1.json
     */
    format(results) {
        const output = [];

        for (let i = 0; i < results.length; i++) {
            let result = results[i];

            if (!result || !result.hasOwnProperty('resultType') || !result.resultType){
                continue;
            }

            if (this.skipAwaiting && result.IsInvalid === -1) {
                continue;
            }

            try {
                switch (result.resultType) {
                    case ResultType.Pitch.key:
                        output.push(this.formatPitch(result));
                        break;
                
                    case ResultType.Hit.key:
                        output.push(this.formatHit(result));
                        break;
                    
                    case 'PH':
                        output.push(this.formatPitch(result));
                        output.push(this.formatHit(result));
                        break;
    
                    default:
                        // TODO - log ?
                        break;
                }
            }
            catch (error) {
                // TODO - log
                continue;
            }
        }

        return output;
    }

    formatPitch(result) {
        // copy all generic first level items
        const pitch = this.fillStructure(result);

        // fill pitch specific stuff
        pitch[ResultData.Id.key] = result.pitchResultID;
        pitch[ResultData.TagId.key] = result.pitcherTagID;
        pitch[ResultData.HitId.key] = result.hitResultID;
        pitch[ResultData.BatterTagId.key] = result.batterTagID;
        pitch[ResultData.Type.key] = ResultType.Pitch.key;
        pitch[ResultData.Data.key] = Object.assign(
            {},
            result.data.common || {},
            result.data.sensor.pitch || {},
            result.data.tagging.pitch || {},
            result.data.scoring || {}
        );
        if (result.media) {
            pitch[ResultData.Media.key] = result.media.pitch || [];
        }
        else {
            pitch[ResultData.Media.key] = [];
        }

        return pitch;
    }

    formatHit(result) {
        // copy all generic first level items
        const hit = this.fillStructure(result);

        // fill hit specific stuff
        hit[ResultData.Id.key] = result.hitResultID;
        hit[ResultData.TagId.key] = result.batterTagID;
        hit[ResultData.Type.key] = ResultType.Hit.key;
        hit[ResultData.PitchId.key] = result.pitchResultID;
        hit[ResultData.Data.key] = Object.assign(
            {},
            result.data.common || {},
            result.data.sensor.hit || {},
            result.data.tagging.hit || {},
            result.data.scoring || {}
        );
        if (result.media) {
            hit[ResultData.Media.key] = result.media.hit || [];
        }
        else {
            hit[ResultData.Media.key] = [];
        }

        return hit;
    }

    fillStructure(result) {
        const filled = Object.assign({}, this.resultStructure);
        //filled[ResultData.Id.key] = result.id;
        filled[ResultData.IsInvalid.key] = result.IsInvalid;
        filled[ResultData.PitchId.key] = result.pitchResultID;
        filled[ResultData.SessionId.key] = result.sessionID;
        //filled[ResultData.Type.key] = result.resultType;
        filled[ResultData.CreateDate.key] = result.createDate;
        filled[ResultData.HitId.key] = result.hitResultId;
        //filled[ResultData.AtBatIndex.key] = NaN;

        return filled;
    }
};

export default SessionResultsStructureFormatter;